<template>
    <b-modal
            no-enforce-focus
            ref="contentListModal"
            :id="id"
            no-close-on-backdrop
            size="xl"
            :title="formData.label ? formData.label : 'New Page'">
        <template slot="modal-footer">
            <b-button variant="secondary" @click="$refs.contentListModal.hide()">
                CANCEL
            </b-button>
            <pb-btn :busy="busy" variant="primary" v-on:click.native="onSubmit()">
                SAVE
            </pb-btn>
        </template>
        <b-container class="text-left">
            <b-row>
                <b-col>
                    <b-form>
                        <b-row class="my-2" v-if="submitError">
                            <b-col>
                                <b-alert variant="danger" show>{{submitError}}</b-alert>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col>
                                <form-generator :schema="schema" :value="formData">
                                </form-generator>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>
<script>


    import ContentAPI from "@shared/_api/cms/content";
    import FormGenerator from "../form/FormGenerator";

    function initialData() {
        return {
            busy: false,
            submitError: null,
            selectedTemplate: null,
            templateList: [],
            schema: {},
            formData: {
                id: null,
                listId: null,
                contentDataSet: [],
            }
        }
    }

    export default {
        name: 'content-list-modal',
        props: {
            id: String
        },
        data() {
            return initialData();
        },
        components: {
            "form-generator": FormGenerator
        },
        methods: {
            manageEntity(entity) {
                this.$validator.reset().finally(() => {
                    Object.assign(this.$data, initialData());
                    Object.assign(this.$data.formData, entity);
                    Object.assign(this.$data.schema, entity.template.templateFields);
                });
            },
            onSubmit() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.busy = true;
                        ContentAPI.insertListItem(this.formData).then(() => {
                            this.$nextTick(() => {
                                this.$emit('saved');
                                this.$refs.contentListModal.hide();
                            })
                        }).catch(() => {
                            this.submitError = "An error occured.";
                        }).finally(() => {
                            this.busy = false;
                        });
                    }
                });
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            }
        },
        computed: {
            templateOptions() {
                return this.templateList.map(template => {
                    return {
                        value: template.id,
                        text: template.label
                    }
                })
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
